export default __webpack_public_path__ + "static/media/166.6df45a30.jpg";